import React, { forwardRef } from "react";
import {
  useSmartDownload,
  getDownloadLabel,
  DOWNLOAD_GRADIENT,
} from "../../hooks/useSmartDownload";
import DownloadOSIcon from "./DownloadOSIcon";

const DownloadButton = forwardRef(function DownloadButton({ view }, ref) {
  const smartDownload = useSmartDownload();
  const label = getDownloadLabel();
  return (
    <div ref={ref}>
      <button
        type="button"
        onClick={() => smartDownload("home_download_button")}
        style={{ background: DOWNLOAD_GRADIENT }}
        className={`${
          view
            ? " anim-preserve scale-100 transition-transform duration-[600ms] ease-out opacity-100"
            : "opacity-0 scale-50"
        } hover:opacity-90 transition-all duration-300 ease-in-out font-inter text-white leading-none lg:text-[15px] md:text-sm text-xs w-max p-2 pr-5 flex items-center gap-2 rounded-full font-semibold shadow-md`}
      >
        <span className="bg-white lg:p-2 p-1.5 rounded-full flex items-center justify-center">
          <DownloadOSIcon className="lg:w-5 w-4 lg:h-5 h-4 text-[#407BFF]" />
        </span>
        {label}
      </button>
    </div>
  );
});

export default DownloadButton;
